// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessRouteImport } from './routes/access'
import { Route as CaseStudiesRouteImport } from './routes/case-studies_'
import { Route as GuidesRouteImport } from './routes/guides_'
import { Route as ListingCreativePackRouteImport } from './routes/listing-creative-pack'
import { Route as MetaAdsAuditRouteImport } from './routes/meta-ads-audit'
import { Route as MetaAdsDiagnosticRouteImport } from './routes/meta-ads-diagnostic'
import { Route as MetaAdsForEcommerceRouteImport } from './routes/meta-ads-for-ecommerce'
import { Route as MetaAdsManagementRouteImport } from './routes/meta-ads-management'
import { Route as MetaAdsPricingRouteImport } from './routes/meta-ads-pricing'
import { Route as MetaPixelConversionsApiRouteImport } from './routes/meta-pixel-conversions-api'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RealEstateLeadGenerationMetaAdsRouteImport } from './routes/real-estate-lead-generation-meta-ads'
import { Route as StartRouteImport } from './routes/start'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as CaseStudiesLocalLeadGenerationMetaAdsRouteImport } from './routes/case-studies.local-lead-generation-meta-ads'
import { Route as CaseStudiesSkincareTransformationRouteImport } from './routes/case-studies.skincare-transformation'
import { Route as GuidesDubaiPropertyAdPermitRouteImport } from './routes/guides.dubai-property-ad-permit'
import { Route as GuidesMetaAdsCampaignStructureRouteImport } from './routes/guides.meta-ads-campaign-structure'
import { Route as GuidesMetaAdsCreativeTestingRouteImport } from './routes/guides.meta-ads-creative-testing'
import { Route as GuidesMetaAdsLearningPhaseRouteImport } from './routes/guides.meta-ads-learning-phase'
import { Route as GuidesMetaAdvantagePlusRouteImport } from './routes/guides.meta-advantage-plus'
import { Route as GuidesMetaHousingRulesDubaiPropertyRouteImport } from './routes/guides.meta-housing-rules-dubai-property'
import { Route as GuidesWhyMetaAdCostsRiseRouteImport } from './routes/guides.why-meta-ad-costs-rise'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessRoute = AccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies_',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides_',path: '/guides',getParentRoute: () => rootRouteImport
          })
const ListingCreativePackRoute = ListingCreativePackRouteImport.update({
            id: '/listing-creative-pack',path: '/listing-creative-pack',getParentRoute: () => rootRouteImport
          })
const MetaAdsAuditRoute = MetaAdsAuditRouteImport.update({
            id: '/meta-ads-audit',path: '/meta-ads-audit',getParentRoute: () => rootRouteImport
          })
const MetaAdsDiagnosticRoute = MetaAdsDiagnosticRouteImport.update({
            id: '/meta-ads-diagnostic',path: '/meta-ads-diagnostic',getParentRoute: () => rootRouteImport
          })
const MetaAdsForEcommerceRoute = MetaAdsForEcommerceRouteImport.update({
            id: '/meta-ads-for-ecommerce',path: '/meta-ads-for-ecommerce',getParentRoute: () => rootRouteImport
          })
const MetaAdsManagementRoute = MetaAdsManagementRouteImport.update({
            id: '/meta-ads-management',path: '/meta-ads-management',getParentRoute: () => rootRouteImport
          })
const MetaAdsPricingRoute = MetaAdsPricingRouteImport.update({
            id: '/meta-ads-pricing',path: '/meta-ads-pricing',getParentRoute: () => rootRouteImport
          })
const MetaPixelConversionsApiRoute = MetaPixelConversionsApiRouteImport.update({
            id: '/meta-pixel-conversions-api',path: '/meta-pixel-conversions-api',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RealEstateLeadGenerationMetaAdsRoute = RealEstateLeadGenerationMetaAdsRouteImport.update({
            id: '/real-estate-lead-generation-meta-ads',path: '/real-estate-lead-generation-meta-ads',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const CaseStudiesLocalLeadGenerationMetaAdsRoute = CaseStudiesLocalLeadGenerationMetaAdsRouteImport.update({
            id: '/case-studies/local-lead-generation-meta-ads',path: '/case-studies/local-lead-generation-meta-ads',getParentRoute: () => rootRouteImport
          })
const CaseStudiesSkincareTransformationRoute = CaseStudiesSkincareTransformationRouteImport.update({
            id: '/case-studies/skincare-transformation',path: '/case-studies/skincare-transformation',getParentRoute: () => rootRouteImport
          })
const GuidesDubaiPropertyAdPermitRoute = GuidesDubaiPropertyAdPermitRouteImport.update({
            id: '/guides/dubai-property-ad-permit',path: '/guides/dubai-property-ad-permit',getParentRoute: () => rootRouteImport
          })
const GuidesMetaAdsCampaignStructureRoute = GuidesMetaAdsCampaignStructureRouteImport.update({
            id: '/guides/meta-ads-campaign-structure',path: '/guides/meta-ads-campaign-structure',getParentRoute: () => rootRouteImport
          })
const GuidesMetaAdsCreativeTestingRoute = GuidesMetaAdsCreativeTestingRouteImport.update({
            id: '/guides/meta-ads-creative-testing',path: '/guides/meta-ads-creative-testing',getParentRoute: () => rootRouteImport
          })
const GuidesMetaAdsLearningPhaseRoute = GuidesMetaAdsLearningPhaseRouteImport.update({
            id: '/guides/meta-ads-learning-phase',path: '/guides/meta-ads-learning-phase',getParentRoute: () => rootRouteImport
          })
const GuidesMetaAdvantagePlusRoute = GuidesMetaAdvantagePlusRouteImport.update({
            id: '/guides/meta-advantage-plus',path: '/guides/meta-advantage-plus',getParentRoute: () => rootRouteImport
          })
const GuidesMetaHousingRulesDubaiPropertyRoute = GuidesMetaHousingRulesDubaiPropertyRouteImport.update({
            id: '/guides/meta-housing-rules-dubai-property',path: '/guides/meta-housing-rules-dubai-property',getParentRoute: () => rootRouteImport
          })
const GuidesWhyMetaAdCostsRiseRoute = GuidesWhyMetaAdCostsRiseRouteImport.update({
            id: '/guides/why-meta-ad-costs-rise',path: '/guides/why-meta-ad-costs-rise',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessRoute: AccessRoute,CaseStudiesRoute: CaseStudiesRoute,GuidesRoute: GuidesRoute,ListingCreativePackRoute: ListingCreativePackRoute,MetaAdsAuditRoute: MetaAdsAuditRoute,MetaAdsDiagnosticRoute: MetaAdsDiagnosticRoute,MetaAdsForEcommerceRoute: MetaAdsForEcommerceRoute,MetaAdsManagementRoute: MetaAdsManagementRoute,MetaAdsPricingRoute: MetaAdsPricingRoute,MetaPixelConversionsApiRoute: MetaPixelConversionsApiRoute,PrivacyRoute: PrivacyRoute,RealEstateLeadGenerationMetaAdsRoute: RealEstateLeadGenerationMetaAdsRoute,StartRoute: StartRoute,StudioRoute: StudioRoute,TermsRoute: TermsRoute,CaseStudiesLocalLeadGenerationMetaAdsRoute: CaseStudiesLocalLeadGenerationMetaAdsRoute,CaseStudiesSkincareTransformationRoute: CaseStudiesSkincareTransformationRoute,GuidesDubaiPropertyAdPermitRoute: GuidesDubaiPropertyAdPermitRoute,GuidesMetaAdsCampaignStructureRoute: GuidesMetaAdsCampaignStructureRoute,GuidesMetaAdsCreativeTestingRoute: GuidesMetaAdsCreativeTestingRoute,GuidesMetaAdsLearningPhaseRoute: GuidesMetaAdsLearningPhaseRoute,GuidesMetaAdvantagePlusRoute: GuidesMetaAdvantagePlusRoute,GuidesMetaHousingRulesDubaiPropertyRoute: GuidesMetaHousingRulesDubaiPropertyRoute,GuidesWhyMetaAdCostsRiseRoute: GuidesWhyMetaAdCostsRiseRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)